import request from '@/utils/request'

export function searchBhApi(data) {
  return request({
    url: '/baohan/getBaohanInfoByCode',
    method: 'post',
    data
  })
}

export function getBhInfoApi(data) {
  return request({
    url: '/baohan/getBaohanInfoByCode',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/http.js